module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "placeInTop": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v("Opret klassefravær")])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [(_vm.isMultipleSchoolsActive && !_vm.activeSchoolId) ? [_c('div', {
    staticClass: "d-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Vælg skole for klassefravær")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeSchoolId),
      expression: "activeSchoolId"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.activeSchoolId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onChangeActiveSchoolId]
    }
  }, _vm._l((_vm.userSchoolsSorted), function(school) {
    return _c('option', {
      domProps: {
        "value": school.id
      }
    }, [_vm._v("\n              " + _vm._s(school.name) + "\n            ")])
  }), 0)])] : (_vm.activeSchoolId && (_vm.isLoadingSchoolCalendars || _vm.isLoadingSchoolYears)) ? [_c('div', {
    staticClass: "do-spinner__container"
  }, [_c('div', {
    staticClass: "do-spinner do-spinner--large"
  })])] : [_c('div', {
    staticClass: "d-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Vælg klasse")]), _vm._v(" "), _c('DSelectCals', {
    attrs: {
      "items": _vm.klassCalendars,
      "itemsSelected": _vm.selectedKlasses,
      "multiple": false,
      "placeholder": _vm.$t('vue2.dselect.placeholder_calendars'),
      "showCalendarYear": true
    },
    on: {
      "update": _vm.setSelectedKlasses
    }
  })], 1), _vm._v(" "), (_vm.selectedKlasses.length > 0) ? [_c('OutOfSchoolSubject', {
    attrs: {
      "schoolId": _vm.activeSchoolId,
      "calendarId": _vm.selectedKlasses[0]['id'],
      "date": _vm.startDate,
      "selectedSubject": _vm.selectedSubject
    },
    on: {
      "setSubject": _vm.setSelectedSubject
    }
  })] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Deltagende personer")]), _vm._v(" "), _c('DSelectCals', {
    attrs: {
      "items": _vm.userCalendars,
      "itemsSelected": _vm.selectedUsers,
      "multiple": true,
      "placeholder": _vm.$t('vue2.dselect.placeholder_calendars')
    },
    on: {
      "update": _vm.setSelectedUsers
    }
  })], 1), _vm._v(" "), (_vm.selectedUsers.length > 0) ? [_c('OutOfSchoolAbsence', {
    on: {
      "setSubject": _vm.setSelectedAbsence
    }
  })] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Dato")]), _vm._v(" "), _c('DatepickerRange', {
    attrs: {
      "allowSameDate": true,
      "startdate": _vm.date
    },
    on: {
      "startchanged": _vm.setStartDate,
      "endchanged": _vm.setEndDate
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "time-changer__group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Tid")]), _vm._v(" "), _c('TimeChanger', {
    attrs: {
      "showIcon": true,
      "start": _vm.startTime,
      "end": _vm.endTime,
      "isFiveMinutesInterval": false
    },
    on: {
      "updateStart": _vm.setStartTime,
      "updateEnd": _vm.setEndTime
    }
  })], 1)]], 2), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons d-modal__buttons__padding",
    staticStyle: {
      "padding": "1rem 3rem"
    }
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isValidated) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.create')) + "\n      ")]) : _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSubmitting
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.create')) + "\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9d81f044!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/OutOfSchool/OutOfSchool.vue
// module id = 1728
// module chunks = 1